module.exports = __webpack_public_path__ + "static/img/step6.6d4c3f54.jpg";